import { CompositeScreenProps } from '@react-navigation/native'
import { platform } from 'constants'
import React from 'react'
import { ScrollView, StyleSheet } from 'react-native'

import { EmergingCoaches } from 'partials/EmergingCoaches/EmergingCoaches'
import { Page } from 'partials/Page'

import { Box } from 'widgets/Box'
import { CoachItem } from 'widgets/CoachItem'
import { FlatList } from 'widgets/FlatList'
import { Title } from 'widgets/Title'

import { useCoaches } from 'hooks/useCoaches'
import { useDiscoverContent } from 'hooks/useDiscoverContent'
import { useMaxWidth } from 'hooks/useMaxWidth'
import { useTopCoaches } from 'hooks/useTopCoaches'

import commonStyles from 'utils/styles/commonStyles'

import { useTheme } from 'contexts/ThemeContext'

import { UserType } from 'types/user'

const styles = StyleSheet.create({
  allCoachesList: {
    alignSelf: 'center',
  },
})

export const CoachesPage = ({ navigation }: CompositeScreenProps<any, any>) => {
  const theme = useTheme()

  const { data: discoverContent } = useDiscoverContent()
  const { data: topCoaches, isLoading: isLoadingTopCoaches } = useTopCoaches()
  const {
    data: allCoaches,
    isLoading: isLoadingAllCoaches,
    fetchNextPage: fetchNextAllCoachesPage,
    hasNextPage,
  } = useCoaches()

  const { width } = useMaxWidth()
  const numColumns = Math.floor(width / (theme.spacing.sm * 2 + 66)) - 1

  return (
    <Page backgroundColor='white' title='Groups' withNav withBack navigation={navigation}>
      <Box flex={1} padding='sm'>
        <ScrollView>
          <EmergingCoaches />
          <Title bold>{discoverContent?.sections[2]?.name}</Title>
          {!isLoadingTopCoaches && (
            <Box
              testID='TopCoachesRow'
              flexDirection={topCoaches && topCoaches.length > 0 ? 'row' : 'column'}
              justifyContent='flex-start'
              width='100%'
              margin={{ top: 'md', bottom: 'md' }}
              style={platform.IS_WEB ? commonStyles.overflowScroll : undefined}
            >
              <FlatList<UserType>
                horizontal
                data={topCoaches?.filter((coach) => !!coach)}
                loading={isLoadingTopCoaches}
                renderItem={({ item: user }) => <CoachItem user={user} isSquare />}
                keyExtractor={(user) => `TopCoaches-${user?.id}`}
                testID='TopCoachesList'
                noContentProps={{
                  marginTop: 50,
                  marginBottom: 50,
                  message: 'There are no top Groups right now. Check back later!',
                }}
                contentContainerStyle={commonStyles.flexGrow}
              />
            </Box>
          )}
          <Title bold>All Groups</Title>
          {!isLoadingAllCoaches && (
            <Box
              testID='AllCoachesRow'
              justifyContent='flex-start'
              width='100%'
              margin={{ top: 'md', bottom: 'md' }}
            >
              <FlatList<UserType>
                testID='AllCoachesList'
                key={numColumns}
                style={styles.allCoachesList}
                scrollEnabled={false}
                numColumns={numColumns}
                initialNumToRender={20}
                data={allCoaches}
                loading={isLoadingAllCoaches}
                renderItem={({ item: user }) => <CoachItem user={user} isSquare />}
                keyExtractor={(user) => `AllCoaches-${user?.id}`}
                noContentProps={{
                  marginTop: 50,
                  marginBottom: 50,
                  message: 'There are no Groups available right now. Check back later!',
                }}
                onEndReached={() => hasNextPage && fetchNextAllCoachesPage()}
              />
            </Box>
          )}
        </ScrollView>
      </Box>
    </Page>
  )
}
